<template>
  <div>
    <yd-table
      :settings="false"
      :data="logList"
      :border="true"
      :loading="loading"
      max-height="400px"
      size="small"
      tooltip-effect="dark"
      @onChange="onTableChange"
    >
      <el-table-column prop="recordTime" label="操作时间" width="150" />
      <el-table-column prop="operator" label="操作方" width="150">
        <template slot-scope="scope">
          {{ scope.row.operator || '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="operatorName" label="操作人" width="150">
        <template slot-scope="scope">
          <yd-link
            v-if="scope.row.operatorUserIdType === 2"
            :value="scope.row.operatorName || scope.row.operateUserName"
            :type="'systemUser'"
            :query="{ userId: scope.row.unionUserId }"
          />
          <yd-link
            v-else-if="scope.row.operatorUserIdType === 1"
            permi="user_center_manage"
            :value="scope.row.operatorName || scope.row.operateUserName"
            :url="`/customer/user/index/${scope.row.operatorName || scope.row.operateUserName}/${
              scope.row.unionUserId
            }`"
            type="userInfo"
            :need="true"
          />
          <span v-else>{{ scope.row.operatorName || scope.row.operateUserName }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="operateTypeMsg" label="操作类型" width="150">
        <template slot-scope="scope">
          {{ scope.row.operateTypeMsg || scope.row.operateType }}
        </template>
      </el-table-column>
      <el-table-column prop="newRecord" label="操作内容">
        <template slot-scope="scope">
          <template v-if="scope.row.operateType == 20005">
            <div
              class="image-view"
              v-for="(item, index) in (scope.row.newRecord || '').split(',')"
              :key="`${item}_${index}`"
            >
              <i class="el-icon-zoom-in icon"></i>
              <el-image :src="item" :preview-src-list="(scope.row.newRecord || '').split(',')" />
            </div>
          </template>
          <template v-else>
            <span
              v-if="type === 2 && status === '已改签'"
              style="white-space: pre-wrap"
              v-html="scope.row.newRecord ? `生成新订单：${scope.row.newRecord}` : '无'"
            ></span>
            <span v-else style="white-space: pre-wrap" v-html="scope.row.newRecord || '无'"></span>
          </template>
        </template>
      </el-table-column>
      <el-table-column prop="oldRecord" label="原内容">
        <template slot-scope="scope">
          <span
            v-if="type === 2 && status === '已改签'"
            style="white-space: pre-wrap"
            v-html="scope.row.oldRecord ? `原订单：${scope.row.oldRecord}` : '无'"
          ></span>
          <span v-else style="white-space: pre-wrap" v-html="scope.row.oldRecord || '无'"></span>
        </template>
      </el-table-column>
    </yd-table>
  </div>
</template>

<script>
  import { getLog } from '@/api/common'
  export default {
    name: 'LogList',
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      flightPlanId: {
        type: String,
        default: ''
      },
      type: {
        type: Number,
        default: 1
      },
      status: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        logList: [],
        loading: false
      }
    },
    methods: {
      onTableChange({ type }) {
        if (type === 'fresh') {
          this.getLogData()
        }
      },
      async getLogData() {
        try {
          this.loading = true
          const { code, data } = await getLog({
            bizLinkId: this.flightPlanId,
            type: this.type
          })
          if (code === 0) {
            this.logList = data
          }
        } catch (error) {
        } finally {
          this.loading = false
        }
      }
    },
    watch: {
      visible: {
        handler() {
          if (this.visible) {
            this.getLogData()
          }
        },
        immediate: true
      }
    }
  }
</script>
<style scoped lang="scss">
  .image-view {
    display: inline-block;
    width: 25px;
    height: 25px;
    border-radius: 5px;
    overflow: hidden;
    position: relative;
    text-align: center;
    margin-left: 5px;
    &:hover {
      cursor: pointer;
      .icon,
      &:after {
        display: block;
        pointer-events: none;
      }
    }
    .icon {
      position: absolute;
      width: 15px;
      height: 15px;
      z-index: 2;
      left: 50%;
      top: 50%;
      font-size: 18px;
      color: #fff;
      transform: translateX(-50%) translateY(-50%);
      display: none;
    }
    &:after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      background: rgba(0, 0, 0, 0.5);
      z-index: 1;
      display: none;
    }
  }
</style>
